import { Lock } from 'lucide-react';
import { MODULE_LABELS } from '@/utils/modules';

/**
 * Angezeigt, wenn ein User auf ein für ihn deaktiviertes Modul navigiert
 * (direkte URL — die Navigation blendet deaktivierte Module aus).
 */
export function ModuleDisabledPage({ moduleKey }: { moduleKey: string }) {
  const label = MODULE_LABELS[moduleKey] ?? moduleKey;

  return (
    <div className="max-w-2xl mx-auto">
      <div className="card p-8 text-center">
        <div className="mx-auto w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-4">
          <Lock className="h-6 w-6 text-gray-400" />
        </div>
        <h1 className="text-xl font-semibold text-gray-900 mb-2">Modul nicht aktiviert</h1>
        <p className="text-gray-600">
          Sie haben keinen Zugriff auf das Modul „{label}". Wenden Sie sich an Ihren Administrator.
        </p>
      </div>
    </div>
  );
}